import React from "react";
import { Layout, Alert, Spin } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import MainNav from "../Navbars/MainNav";
import Sidebar from "../Navbars/Sidebar";
import useUser from "../../../hooks/useUser";
import { useGetMyStatusQuery } from "../../../redux/api/User/UserApi";
import { useGetMySubscriptionQuery } from "../../../redux/api/Subscription/SubscriptionApi";
import { useLayout } from "../../../context/LayoutContext";
import SubscriptionReminder from "./components/SubscriptionReminder";
import BlockerUI from "./components/BlockerUI";
import "./AdminLayout.css";
import Loader from "../../../Components/Loader";

const { Content } = Layout;

const AdminLayout = () => {
  const location = useLocation();
  const { role } = useUser();
  useLayout(); // Keep the hook call even if not using the values

  // Fetch data
  const { data: statusData, isLoading, isError } = useGetMyStatusQuery();
  const { data: subscriptionData } = useGetMySubscriptionQuery();

  // Extract status flags
  const isWhatsappConnected = statusData?.data?.isWhatsappConnected || false;
  const hasSubscription = statusData?.data?.hasSubscription || false;
  const isAdmin = role === "admin";

  // Determine what to show - admins bypass all checks
  const shouldShowBlocker = !isAdmin && (!isWhatsappConnected || !hasSubscription);

  // If on setup pages, don't show blocker
  const isOnSetupPage =
    location.pathname.includes("/whatsapp-connect") ||
    location.pathname.includes("/browse-plans");

  const showContent = !shouldShowBlocker || isOnSetupPage;

  return (
    <Layout className="admin-layout-wrapper">
      <MainNav />
      <Layout hasSider>
        {/* Desktop Sidebar */}
        <div className="desktop-only">
          <Sidebar />
        </div>

        {/* Mobile Sidebar (Drawer) */}
        <div className="mobile-only">
          <Sidebar isMobile={true} />
        </div>

        <Layout className="admin-content-layout">
          <Content className="admin-main-content">
            <SubscriptionReminder
              hasSubscription={hasSubscription}
              subscriptionData={subscriptionData}
            />

            {isLoading ? (
              <Loader/>
            ) : isError ? (
              <div className="layout-error">
                <Alert
                  message="Connection Error"
                  description="Failed to load user status. Please refresh the page or contact support."
                  type="error"
                  showIcon
                />
              </div>
            ) : showContent ? (
              <div className="fade-in">
                <Outlet />
              </div>
            ) : (
              <BlockerUI
                isWhatsappConnected={isWhatsappConnected}
                hasSubscription={hasSubscription}
              />
            )}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
